import {formatDateTimes, formatTimeTo} from "../../shared/time-formating";
import Follow from "../../shared/components/follow";
import {loadScript} from "../../shared/load-script";

const _embededPlayers: Array<string> = [];
function handleShowMoreLess(this: HTMLAnchorElement, e: MouseEvent){
    e.preventDefault();

    if (!this.dataset["target"]){
        return;
    }

    const container = document.querySelector<HTMLElement>(`dd[data-id=${this.dataset["target"]}]`)

    if (!container){
        return;
    }

    const dots = container.querySelector<HTMLElement>('.over-dots');
    const profiles = container.querySelector<HTMLElement>('.item-over');
    const mlContainer = this.querySelector<HTMLElement>('span')

    if (!dots || !profiles){
        return;
    }

    let isVisible = false;
    if (dots.classList.contains('hidden')){
        dots.classList.remove('hidden')
        profiles.classList.add('hidden')
    }else{
        dots.classList.add('hidden')
        profiles.classList.remove('hidden')
        isVisible = true
    }

    if (mlContainer){
        if (isVisible){
            mlContainer.textContent = 'Less'
        }else{
            mlContainer.textContent = 'More'
        }
    }
}

function loadEmbed(videoId: string, videoBlock: HTMLElement){
    const url = new URL(`${window.location.origin}/embed/v1/${videoId}/`);

    // /embed/v1/2pcdl/?site=fite&autoplay=1&tr=1&nt=1&return_to=https%3A%2F%2Fdev.fite.tv%2Fwatch%2Faew-dynamite-episode-50-22%2F2pcdl%2F
    url.searchParams.set('site', 'fite');
    url.searchParams.set('nt', "1");
    url.searchParams.set('nfc', "1");
    url.searchParams.set('autoplay', "1");

    const frameId = `trailer-player-${videoId}-embed`;
    const height = Math.round(videoBlock.clientWidth * (9/16)) + 50;

    const iframeEl = document.createElement('iframe');
    iframeEl.setAttribute("id", frameId)
    iframeEl.setAttribute('frameborder', '0');
    iframeEl.setAttribute('style', `width: 100%;height:${height}px;`);
    iframeEl.setAttribute('allowfullscreen', '');
    iframeEl.setAttribute("src", url.href);

    videoBlock.innerHTML = '';
    videoBlock.appendChild(iframeEl);
    _embededPlayers.push(frameId);
}

function _resideEmbeds(): void{
    if (_embededPlayers.length === 0)
        return;

    for(const elId of _embededPlayers){
        const iframeEl = document.querySelector<HTMLElement>(`#${elId}`);
        if (!iframeEl)
            return;
        const videoBlock: HTMLElement | null = iframeEl.parentElement;
        if (!videoBlock)
            return;

        iframeEl.style.height = Math.round(videoBlock.clientWidth * (9/16)) + 50 + "px";
    }
}

function initMoreLess(){
    document.querySelectorAll<HTMLAnchorElement>("a.more-profiles").forEach((el: HTMLAnchorElement) => {
        el.addEventListener("click", handleShowMoreLess);
    })
}

function initEmbedPlayer(){
    const containerEl = document.querySelector<HTMLElement>('#embed-player-view')
    if (!containerEl || !containerEl.dataset["id"])
        return;
    const videoId = containerEl.dataset["id"];
    const embedContainer = containerEl.querySelector<HTMLElement>('.embed-player-wrapper')
    if (!embedContainer){
        return;
    }
    loadEmbed(videoId, embedContainer);
    window.addEventListener("resize", _resideEmbeds);
}

function handleShowDescription(this: HTMLLabelElement){
    if (!this.parentElement){
        return
    }
    const elAnchor = document.createElement('a');
    elAnchor.setAttribute('href', "#");
    elAnchor.setAttribute('class', 'text-mono-ps-200 font-bold flex py-3 justify-end')
    elAnchor.appendChild(document.createTextNode('Less'));
    elAnchor.addEventListener('click', function (this: HTMLAnchorElement, ev){
        ev.preventDefault();
        if (this.parentElement){
            const checkbox: HTMLInputElement|null = this.parentElement.querySelector<HTMLInputElement>('[type="checkbox"]')
            if (checkbox){
                checkbox.checked = false;
            }
        }
        this.remove();
    })
    this.parentElement.appendChild(elAnchor)
}

function initObservers(){
    const ps = document.querySelectorAll('.expandable');
    const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
            entry.target.classList[Math.round(entry.target.scrollHeight) > Math.round(entry.contentRect.height) ? 'add' : 'remove']('truncated');
        }
    });

    ps.forEach(p => {
        observer.observe(p);
    });

    document.querySelectorAll<HTMLLabelElement>('label[for="expanded"]').forEach((entry: HTMLLabelElement) => {
        entry.addEventListener('click', handleShowDescription)
    })

    document.addEventListener("scroll", handleTwitter, {once: true})
    document.addEventListener("mousemove", handleTwitter, {once: true})
}

function handleTwitter(){
    document.removeEventListener("scroll", handleTwitter)
    document.removeEventListener("mousemove", handleTwitter)
    const el = document.querySelector<HTMLAnchorElement>(".twitter-timeline");
    if (el){
        loadScript("https://platform.twitter.com/widgets.js")
            .then().catch();
    }

}

function initFollow(): void{
    new Follow()
}

function initFilters(){
    if (!document.querySelector('.search-filters'))
        return

    const leftBtn = document.querySelector<HTMLElement>('.left-nav');
    const rightBtn = document.querySelector<HTMLElement>('.right-nav');
    const filtersList = document.querySelector<HTMLUListElement>('#search-filters');

    if (!leftBtn || !rightBtn || !filtersList)
        return;

    leftBtn.addEventListener("click", function (){
        filtersList.scrollLeft = filtersList.scrollLeft - 250;
    })
    rightBtn.addEventListener("click", function (){
        filtersList.scrollLeft = filtersList.scrollLeft + 250;
    })
    // not sure about this one
    filtersList.addEventListener("wheel", function(this, evt){
        evt.preventDefault();
        if (evt.deltaX !== 0){
            this.scrollLeft = this.scrollLeft + evt.deltaX;
        }else{
            this.scrollLeft = this.scrollLeft + evt.deltaY;
        }
    });
}

function handleBuyButton(this: HTMLElement, e: MouseEvent){
    e.preventDefault();
    const width = 1024, height = 720;
    const left = (screen.width - width) / 2, top = (screen.height - height) / 4;

    const el = e.target;
    if (el instanceof HTMLElement){
        const url = el.dataset.href + '&return_to=' + encodeURIComponent(window.location.href);
        const newWindow: Window | null = window.open(url, el.dataset.name,'width=' + width + ',height=' + height + ', top=' + top + ', left=' + left);
        if (newWindow){
            newWindow.focus()
        }
        // if (window.dataLayer){
        //     window.dataLayer.push({
        //         'event': 'add_to_cart',
        //         'ecomm_prodid': el.dataset.id,
        //         'ecomm_pagetype': 'cart',
        //         'ecomm_totalvalue': el.dataset.price,
        //         'package_id': el.dataset.id,
        //         'package_name': el.dataset.name,
        //         'price': el.dataset.price,
        //         'site': 'fite'
        //     })
        // }

    }

    return false;
}

document.querySelectorAll<HTMLElement>(".buy-button").forEach((el: HTMLElement) => {
    el.addEventListener("click", handleBuyButton);
})

document.querySelectorAll<HTMLAnchorElement>("a[data-ref][data-vid]").forEach((el: HTMLAnchorElement) => {
    el.addEventListener("click", function (this: HTMLAnchorElement) {
        if (!this.dataset.ref || !this.dataset.vid)
            return;
        try {
            localStorage.setItem(this.dataset.vid, this.dataset.ref);
        }catch(e){
            console.error(e);
        }
    });
})


initObservers();
formatDateTimes();
formatTimeTo();
initMoreLess();
initEmbedPlayer();
initFollow();
initFilters();
